import { IConsentObject } from '../../../models/ConsentObject';
import { IPersonalInfo } from '../../../models/PersonalInfo';
import { PersonalInfoAdressErrors, PersonalInfoErrors, State } from './reducer';
import { PayloadAction } from '@reduxjs/toolkit';

export const setPersonalInfo = (
	state: State,
	action: PayloadAction<IPersonalInfo>
) => {
	state.personalInfo = action.payload;
};

export const setPersonalInfoErrors = (
	state: State,
	action: PayloadAction<PersonalInfoErrors>
) => {
	state.personalInfoErrors = action.payload;
};

export const setPersonalInfoRAdressErrors = (
	state: State,
	action: PayloadAction<PersonalInfoAdressErrors>
) => {
	state.personalInfoRAdressErrors = action.payload;
};

export const setStartDate = (state: State, action: PayloadAction<string>) => {
	state.startDate = action.payload;
};

export const setConsentsStep1 = (
	state: State,
	action: PayloadAction<IConsentObject[]>
) => {
	state.consentsStep1 = action.payload;
};

export const setConsentsStep2 = (
	state: State,
	action: PayloadAction<IConsentObject[]>
) => {
	state.consentsStep2 = action.payload;
};

export const setSelectedRisksIds = (
	state: State,
	action: PayloadAction<number[]>
) => {
	state.selectedRisksIds = action.payload;
};

export const setVereficationCode = (
	state: State,
	action: PayloadAction<string>
) => {
	state.vereficationCode = action.payload;
};

export const setPaywallUrl = (
	state: State,
	action: PayloadAction<string | null>
) => {
	state.paywallUrl = action.payload;
};

export const setIsLoaded = (state: State, action: PayloadAction<boolean>) => {
	state.loaded = action.payload;
};

export const setVereficationCodeError = (
	state: State,
	action: PayloadAction<string>
) => {
	state.vereficationCodeError = action.payload;
};

export const setFormAccessible = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.formAccessible = action.payload;
};

export const setExtendedOcCoverageSelected = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.extendedOcCoverageSelected = action.payload;
};

export const setFormSuccess = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.formSuccess = action.payload;
};

export const setShowStage1Error = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.showStage1Error = action.payload;
};

export const setShowStage2Error = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.showStage2Error = action.payload;
};

export const setHasBusiness = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.hasBusiness = action.payload;
};
